import { Grid, Space } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import { RentalSuccessStatus } from 'app/constants/Enums'
import { RecordType } from 'app/constants/GlobalTypes'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCreate, useUpdate } from 'app/lib/hooks/useApi'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import { Routes } from 'app/routes/Routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberProps } from '../convention'

type Props = {
  loading?: boolean
  disabled?: boolean
}

const ConfirmationButtons: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { loading, disabled } = {}
}) => {
  const { tCore } = useTranslation({
    scope: 'confirmation_buttons',
    recordType: RecordTypeEnum.rental
  })

  const { parameterize } = ToolBox
  const navigate = useNavigate()
  const { goBack } = useBrowserRouterContext()
  const { md } = Grid.useBreakpoint()
  const { loading: loadingUpdate, execute: updateRental } = useUpdate<IRental>(
    RecordType.rental,
    null,
    true
  )
  const { loading: loadingBooking, execute: directBooking } = useCreate(
    RecordType.direct_booking,
    null,
    true
  )

  const onRequest = async () => {
    await updateRental({ id: member.id, is_requested: true })
    navigate({
      pathname: Routes.Rental.member(member.id.toString()).show,
      search: parameterize({ success: RentalSuccessStatus.created })
    })
  }

  const onDirectBooking = async () => {
    await directBooking({ id: member.id })
    navigate({
      pathname: Routes.Rental.member(member.id.toString()).show,
      search: parameterize({ success: RentalSuccessStatus.booked })
    })
  }

  return (
    <Space className="full-width-space-item">
      <If condition={md}>
        <KButton
          recordType={RecordType.checkout}
          action="go_back"
          type="secondary"
          onClick={goBack}
          title={tCore({ id: 'back_to_delivery' })}
        />
      </If>
      <Choose>
        <When condition={member?.directBookable}>
          <KButton
            block
            action="request_quote"
            recordType={RecordType.checkout}
            loading={loadingUpdate || loading}
            onClick={onRequest}
            type="secondary"
            disabled={disabled}
            title={tCore({ id: 'request_quote' })}
          />
          <KButton
            block
            action="book_directly"
            recordType={RecordType.checkout}
            loading={loadingBooking || loading}
            onClick={onDirectBooking}
            type="primary"
            disabled={disabled}
            title={tCore({ id: 'book_direct' })}
          />
        </When>
        <Otherwise>
          <KButton
            action="request_rental"
            recordType={RecordType.checkout}
            loading={loadingUpdate || loading}
            onClick={onRequest}
            type="primary"
            disabled={disabled}
            title={tCore({ id: 'request_rental' })}
          />
        </Otherwise>
      </Choose>
    </Space>
  )
}

export default ConfirmationButtons
